/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { FluidDataStoreRuntime } from "@fluidframework/datastore/internal";
import { SharedMap, DirectoryFactory, MapFactory, 
// eslint-disable-next-line import/no-deprecated
SharedDirectory, } from "@fluidframework/map/internal";
import { PureDataObjectFactory } from "./pureDataObjectFactory.js";
/**
 * DataObjectFactory is the IFluidDataStoreFactory for use with DataObjects.
 * It facilitates DataObject's features (such as its shared directory) by
 * ensuring relevant shared objects etc are available to the factory.
 *
 * @typeParam TObj - DataObject (concrete type)
 * @typeParam I - The input types for the DataObject
 * @legacy
 * @alpha
 */
export class DataObjectFactory extends PureDataObjectFactory {
    constructor(type, ctor, sharedObjects = [], optionalProviders, registryEntries, runtimeFactory = FluidDataStoreRuntime) {
        const mergedObjects = [...sharedObjects];
        if (!sharedObjects.some((factory) => factory.type === DirectoryFactory.Type)) {
            // User did not register for directory
            // eslint-disable-next-line import/no-deprecated
            mergedObjects.push(SharedDirectory.getFactory());
        }
        // TODO: Remove SharedMap factory when compatibility with SharedMap DataObject is no longer needed in 0.10
        if (!sharedObjects.some((factory) => factory.type === MapFactory.Type)) {
            // User did not register for map
            mergedObjects.push(SharedMap.getFactory());
        }
        super(type, ctor, mergedObjects, optionalProviders, registryEntries, runtimeFactory);
    }
}
//# sourceMappingURL=dataObjectFactory.js.map